import React from 'react';
import '../../assets/css/site.min.css';

/// <summary>
/// Author: -
/// </summary> 
const Theme = () => (<React.Fragment></React.Fragment>);

export default Theme;